import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';
import { Icons } from '../../components/atoms/SVG';
import { SystemPageStatisticsBlock } from '../../_blocks/SystemPageStatistics/SystemPageStatisticsBlock';

export type SystemPageStatisticsWidgetProps = WidgetShape<[SystemPageStatisticsBlock], WidgetType.systempagestatistics>;

export function SystemPageStatisticsWidget({ blocks, ...headerProps }: SystemPageStatisticsWidgetProps) {
  const { t } = useSonTranslation('SystemPageStatistics');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      icon={Icons.CLICK}
      widgetType={WidgetType.systempagestatistics}
      title={t('widgetTitle')}
    >
      {blocks[0] && <SystemPageStatisticsBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
